import { useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { FaSave } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import eventMatchService from '../../../services/eventMatchService';
import { setToastMessage } from "../../../reducers/common.reducer";
import { useDispatch } from "react-redux";
import moment from 'moment/moment';
import ComboBox from '../../../components/ComboBox';
import ConfirmationDialog from '../../../components/ConfirmationDialog';
import { isReversedTeamPair } from '../eventMatching';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 4,
  };

const MatchInfo = (props) => {
    const dispatch = useDispatch();
    const {open,handleClose,event555,event909,matchId,getEvent} = props;
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isEditConfirmOpen, setIsEditConfirmOpen] = useState(false);

    const comboBoxOptions = useMemo(
        () => event555
            .filter((option) => !isReversedTeamPair(
                event909.homeTeam,
                event909.awayTeam,
                option.homeName,
                option.awayName,
            ))
            .map((option) => ({
                ...option,
                id: option.id?.toString() ?? option.id,
                description: `${option.description || '555Mix'}${option.kickoff ? ` · ${moment(option.kickoff).format('HH:mm')}` : ''}`,
            })),
        [event555, event909],
    );

    const filterMatchOptions = (options, query) => {
        const normalizedQuery = query.trim().toLowerCase();
        if (!normalizedQuery) return options;
        return options.filter((option) => [
            option.__label,
            option.__description,
            option.homeName,
            option.awayName,
        ].some((value) => value?.toLowerCase().includes(normalizedQuery)));
    };

    const handleEdit = () => {
        if (!selectedEvent?.id) {
            dispatch(setToastMessage({ type: 'error', message: 'Please select a 555Mix event first.' }));
            return;
        }
        setIsEditConfirmOpen(true);
    };

    const handleEditConfirmed = async () => {
        setIsEditConfirmOpen(false);
        try {
        const payload = {
            eventId555: selectedEvent?.id.toString(),
            eventId909: event909.rapidEventId.toString(),
        };
       
        const res = await eventMatchService.editEventMatch(matchId,payload);
       
        if(res.status == 200)   setSelectedEvent(null);
        await getEvent();
    }
    catch(error){
      
        if(error.response.status == 500){
            dispatch(setToastMessage({ type: "error", message: 'Duplicate match!' }));
        }
    }
       
    }

    const handleOnClose = async () => {
        setSelectedEvent(null);
        handleClose();
    }

  return (
    <>
      <Modal
          open={open}
          onClose={handleOnClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <Box sx={style}>
          <Typography className='text-customFontVoilet mb-2'>
              {event909.homeTeam} vs {event909.awayTeam}
            </Typography>
              <ComboBox
                  options={comboBoxOptions}
                  value={selectedEvent}
                  onChange={setSelectedEvent}
                  placeholder="Search 555 event"
                  emptyState="No direct 555 event found"
                  compact
                  disableShadow
                  disableFocusRing
                  filterOptions={filterMatchOptions}
                  className="w-full"
              />
              <p className="mt-2 text-xs text-amber-700 dark:text-amber-300" role="note">
                  Unmatch is not available yet. Select another 555Mix event to replace this mapping.
              </p>
              <div className='flex justify-center items-center gap-4 mt-2'>
                  <div className='flex items-center gap-2'>
                      <button
                          onClick={handleEdit}
                          className='flex items-center px-3 py-1 border rounded bg-background text-customBackColor'
                      >
                          <FaSave className='mr-1' />Save
                      </button>
                  </div>
                  <div className='flex items-center gap-2'>
                      <button
                          type="button"
                          onClick={handleOnClose}
                          className='flex items-center px-3 py-1 border rounded bg-customTitleColor'
                      ><ImCross className='mr-1' />Cancel
                      </button>
                  </div>
              </div>
          </Box>
      </Modal>
      <ConfirmationDialog
          isOpen={isEditConfirmOpen}
          setIsOpen={setIsEditConfirmOpen}
          title="Confirm match change"
          contextText={`Replace the current 555Mix mapping for ${event909.homeTeam} vs ${event909.awayTeam}?`}
          confirmLabel="Save match"
          cancelLabel="Cancel"
          handleSubmit={handleEditConfirmed}
          appearance="warning"
      />
    </>
  )
}

export default MatchInfo
